import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApiFailure } from '@/lib/api';
import { useLocale } from '@/lib/i18n';
import { App } from './app';
import './index.css';

document.documentElement.lang = useLocale.getState().locale;

// the old console on this address installed an offline cache (service worker); this console uses none — remove a leftover and its caches
// (public/sw.js retires it in browsers that still run the old screens)
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then(async (regs) => {
    if (!regs.length) return;
    await Promise.all(regs.map((r) => r.unregister()));
    if ('caches' in window) for (const k of await caches.keys()) await caches.delete(k);
  });
}

const queries = new QueryClient({
  defaultOptions: {
    // a refusal (4xx) will not change by asking again; a network hiccup might
    queries: { staleTime: 15_000, retry: (n, e) => !(e instanceof ApiFailure && e.status < 500) && n < 2 },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queries}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
